import {Component, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'pbc-app',
  templateUrl: './app.component.html',
  styleUrls: ['../scss/site.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent {
  constructor(){
  }

  onActivate(event : any) {
    let scrollToTop = window.setInterval(() => {
      let pos = window.pageYOffset;
      if (pos > 0) {
        window.scrollTo(0, pos - 20); // how far to scroll on each step
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 16);
  }
 }
